<template>
    <div class="container text-center pt-5 bg-white">
        <div class="row justify-content-center mt-3">

            <div class="col-md-10">

                <img src="/img/logofenig2.png" alt="logoFenig2" class="image img-fluid w-100 p-5"
           style="opacity: .5">

        </div>
    </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        }
    }
</script>
